import { collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { app } from '../../util/firebase';
import UpdateMedoc from './UpdateMedoc';

const MedocList = (props) => {
    const [medocList,setMedocsList] = useState([])
    const [medocID,setMedocId] = useState("")

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"medocs"),snapshot=>{
            setMedocsList(snapshot.docs.map((snap)=>{
                let medoc = snap.data()
                medoc.id = snap.id
                return medoc
            }))
        })
    },[])
    const recoverMedoc=(medoc)=>{
        medoc.isArchived = false
        setDoc(doc(getFirestore(app),"medocs",medoc.id),medoc)
        .then(res=>alert('Médicament récupèré'))
    }
    
    const archiveMedoc =(medoc)=>{
        medoc.isArchived = true
        setDoc(doc(getFirestore(app),"medocs",medoc.id),medoc)
        .then(res=>{
            alert("Médicament archivé")
        })
        .catch(err=>alert(err))
    }
    return (
        <>
            <Routes>
                <Route path='' element={    
                    <div className='row my-2 my-md-5 justify-content-center'>
                        {medocList.map((medoc,index)=>{
                            if(medoc.isArchived === props.isArchived){
                                return (
                                <div key={index} className='col-6 col-md-3 card shadow mx-2 p-3'>
                                    <div style={{minHeight:'180px',backgroundImage:'url('+medoc.imgSrc+')',backgroundPosition:'center',backgroundSize:'cover',backgroundRepeat:'no-repeat'}}></div>
                                    <p className='fs-3'>{medoc.price} FCFA</p>
                                    <p className='fs-4 text-secondary'>{medoc.name} </p>
                                    {
                                        props.isArchived?
                                        <button className='btn col-12 btn-warning' onClick={e=>recoverMedoc(medoc)}>Récupèrer </button>
                                        :
                                        <>
                                            <Link to="updateMedoc">
                                                <button className='btn col-12 btn-primary' onClick={e=>setMedocId(medoc.id)}>Modifier </button>
                                            </Link>
                                            <button type='button' className='btn col-12 my-2 btn-warning m-auto' onClick={e=>archiveMedoc(medoc)}>Archiver le médicament</button>
                                        </>
                                    }
                                </div>
                            )
                            }
                        })}
                    </div>
                }></Route>
                <Route path='updateMedoc/*' element={<UpdateMedoc medocID ={medocID} />}></Route>
            </Routes>
        </>
    );
};

export default MedocList;
